import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Components
import Spinner from 'components/Spinner';
import FailureMessage from 'components/FailureMessage';
import Button from 'components/CncUI/Button';
import Typography from 'components/CncUI/Typography';
import Modal from 'components/CncUI/Modal';
// NPM Components
import { GetApp as DownloadIcon } from '@material-ui/icons';
// Utilities
import Logger from 'utilities/logger';

const useStyles = makeStyles(theme => ({
  dialog: {
    maxWidth: '90vw',
    padding: 4,
  },
  container: {
    minWidth: '30vw',
  },
  loader: {
    fontSize: 16,
  },
  button: {},
}));

const FileDownloader = ({
  urlFetcher,
  config,
  url,
  onClose,
  loaderMessage,
  downloadName,
}) => {
  const logger = Logger('FileDownloader');
  const classes = useStyles();
  const [state, setState] = useState({
    loading: true,
    url: null,
    error: null,
  });
  const modify = data => setState(old => ({ ...old, ...data }));

  useEffect(() => {
    if (url) {
      modify({ url, loading: false });
      return;
    }
    async function fetchData() {
      try {
        const url = await urlFetcher(config);
        modify({ url, loading: false });
      } catch (error) {
        modify({ error, loading: false });
        logger.error(error);
      }
    }
    fetchData();
  }, []);

  return (
    <Modal
      id="File-Downloader-Modal"
      open={true}
      onClose={onClose}
      scroll={'paper'}
      aria-label="FileUrlFetcher-loader"
      data-test-id={`File-Downloader-Modal`}
      classes={{ paper: classes.dialog }}
    >
      {state.loading && (
        <Spinner
          messageProps={{ className: classes.loader }}
          message={
            loaderMessage ||
            'Please wait a moment while we get this file from our secure storage...'
          }
        />
      )}
      {state.error && <FailureMessage onClose={onClose} />}
      {!state.loading && !state.error && !state.url && (
        <FailureMessage onClose={onClose} />
      )}
      {!state.loading && !state.error && state.url && (
        <>
          <Modal.Title onClose={onClose}>Your file is ready</Modal.Title>
          <Modal.Content>
            <Typography variant="body2">
              The prepared link will be valid for 30 seconds
            </Typography>
          </Modal.Content>
          <Modal.Actions>
            <Button
              id="File-Downloader-Button"
              href={state.url}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.button}
              startIcon={<DownloadIcon />}
              download={downloadName}
              onClick={onClose}
            >
              Download
            </Button>
          </Modal.Actions>
        </>
      )}
    </Modal>
  );
};

export default FileDownloader;
